import { render, staticRenderFns } from "./AlertGraphSection.vue?vue&type=template&id=31b53496&"
import script from "./AlertGraphSection.vue?vue&type=script&lang=ts&"
export * from "./AlertGraphSection.vue?vue&type=script&lang=ts&"
import style0 from "./AlertGraphSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports